module.exports = __webpack_public_path__ + "img/p2.cc4ed343.jpg";